import React from "react";
import ProjectContainer from "../Components/ProjectContainer";

const Portfolio = () => {
  return (
    <ProjectContainer projectName="Portfolio">
      {/* <ul className=" px-4 text-base font-medium md:text-lg">
        <li className="mb-1">
          컴포넌트,코드 <span className={pointUsed}>재사용</span>에 대해
          생각하며 만들었다.
        </li>
        <li className="mb-1">
          <span className={pointUsed}>Tailwindcss</span>를 사용해 클래스명에
          대한 고민, 컨텍스트 전환이 적음, 손쉬운 반응형 등의 장점과 재사용이
          어렵고 중복이 많은 단점에 대해 경험하였다.
        </li>
        <li className="mb-1">
          setTimeout을 이용해<span className={pointUsed}>무한 슬라이드</span>를
          구현하였다.
        </li>
        <li className="mb-1">
          <span className={pointUsed}>EmailJS</span>라이브러리를 이용하여 이메일
          전송 기능을 구현하였다.
        </li>
      </ul> */}
    </ProjectContainer>
  );
};

export default Portfolio;
